import { handlePaginatedData } from '../services/DataHelperFunctions';
import { EAction, EActionType, EApiType, EUrlParams } from '../data/Constants';
import AxiosClient from './AxiosClient';
import { handleSuccess, handleError, handleApiErrorWithFallback } from './HttpUtil';
import { IStringResponse } from '../../types/IApiTypes';
import { IError } from '../../types';
import type { Dispatch } from '@reduxjs/toolkit';

export const ProductReleaseApi = {
  //get all product release items from the api
  getProductReleaseData: (payload, dispatch: Dispatch) => {
    let queryParams = new URLSearchParams();
    if (payload.caller !== EActionType.Refresh) {
      queryParams = new URLSearchParams({
        [EUrlParams.Page]: String(payload.page),
        [EUrlParams.Limit]: String(payload.limit),
      });
      if (payload.searchCode) {
        queryParams.set(EUrlParams.Search, payload.searchCode);
      }
    }

    // Only send request body for refresh operations
    const requestBody =
      payload.caller === EActionType.Refresh && payload.searchCode
        ? { filters: { id: payload.searchCode } }
        : {};

    return AxiosClient.post(`productrelease/v1/read?${queryParams.toString()}`, requestBody)
      .then((response) => {
        return handlePaginatedData(response, payload);
      })
      .catch((err) => {
        return handleApiErrorWithFallback(
          dispatch,
          err,
          { page: payload.page, searchKey: payload.searchCode, caller: payload.caller },
          EAction.Read,
          EApiType.ProductReleaseKey
        );
      });
  },

  //retrigger existing product release
  retriggerProductRelease: async (
    payload: { id: string; activities: string[] },
    dispatch: Dispatch
  ) => {
    return AxiosClient.post(`productrelease/v1/retrigger`, payload)
      .then((response: IStringResponse) => {
        return handleSuccess(response);
      })
      .catch((err: IError) => {
        return handleError(dispatch, err, EAction.Retrigger);
      });
  },

  //download product release contents
  downloadProductContents: async (
    payload: { productCode: string; versionId: string },
    dispatch: Dispatch
  ) => {
    return AxiosClient.post('/storage/v1/folder/download', payload, { responseType: 'arraybuffer' })
      .then((response) => {
        return handleSuccess(response, EAction.Download);
      })
      .catch((err) => {
        return handleError(dispatch, err, EAction.Download);
      });
  },
};
